import React, { useEffect, useState } from 'react';

interface CommentData {
  commentid: number;
  roomid: string;
  text: string;
  nickname: string;
  userid?: string;
  createdate: string;
  screenTimestamp: number;
  positionX?: number;
  positionY?: number;
  color?: string;
  fontSize?: number;
  isModerated: number;
}

interface DanmakuCommentProps {
  comment: CommentData;
  onComplete: (commentId: number) => void;
}

const DanmakuComment: React.FC<DanmakuCommentProps> = ({ comment, onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  
  useEffect(() => {
    // コメントの表示時間を計算（文字数ベース）
    const textLength = comment.text.length;
    const duration = Math.max(5000, Math.min(15000, textLength * 200)); // 5秒〜15秒
    
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => onComplete(comment.commentid), 500); // フェードアウト後に削除
    }, duration);
    
    return () => clearTimeout(timer);
  }, [comment, onComplete]);

  if (!isVisible) {
    return null;
  }

  const style: React.CSSProperties = {
    position: 'absolute',
    top: comment.positionY || 0,
    right: 0,
    color: comment.color || '#000000',
    fontSize: `${comment.fontSize || 32}px`,
    fontWeight: '600',
    fontFamily: '"Noto Sans JP", "Yu Gothic", "Hiragino Sans", sans-serif',
    textShadow: '0 1px 3px rgba(255, 255, 255, 0.8), 0 0 8px rgba(255, 255, 255, 0.6)',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    pointerEvents: 'none',
    zIndex: 1000,
    animation: `danmaku-scroll ${Math.max(6, Math.min(12, comment.text.length * 0.15))}s ease-out forwards`,
    transform: 'translateX(100%)',
    letterSpacing: '0.5px',
    opacity: 0.9,
  };

  return (
    <>
      <style>
        {`
          @keyframes danmaku-scroll {
            0% {
              transform: translateX(100%);
              opacity: 0;
            }
            5% {
              opacity: 0.9;
            }
            95% {
              opacity: 0.9;
            }
            100% {
              transform: translateX(-100vw);
              opacity: 0;
            }
          }
        `}
      </style>
      <div style={style}>
        <span>
          {comment.text}
        </span>
      </div>
    </>
  );
};

export default DanmakuComment;